import { render, staticRenderFns } from "./DeclaredGoodsComponent.vue?vue&type=template&id=476e30ce&scoped=true"
import script from "./DeclaredGoodsComponent.vue?vue&type=script&lang=js"
export * from "./DeclaredGoodsComponent.vue?vue&type=script&lang=js"
import style0 from "./DeclaredGoodsComponent.vue?vue&type=style&index=0&id=476e30ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476e30ce",
  null
  
)

export default component.exports